import { Checkbox, Popover, Tooltip } from '@mantine/core';
import { ReactComponent as FolderIcon } from 'assets/icons/folderIcon.svg';
import { ReactComponent as FileIcon } from 'assets/icons/fileIcon.svg';
import { ReactComponent as ImageIcon } from 'assets/icons/imageFile.svg';
import { ReactComponent as MenuDots } from 'assets/icons/menudots.svg';
// import { ReactComponent as UpRight } from 'assets/icons/upRighticon.svg';
import { ReactComponent as PinIcon } from 'assets/icons/pinIcon.svg';
import { ReactComponent as Copy } from 'assets/icons/copy.svg';
import { useState } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import DeleteSubFolderorFile from './deleteSubFoldersorFiles';
import ReNameFolderOrFile from './renameFolder0rFile';
import { saveAs } from 'file-saver';
import PreviewForPDF from './previewForPDF';
import PreviewImage from './PreviewImage';
import MoveFilesOrFolders from './moveFilesOrFolders';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import PreviewVideo from './previewVideo';
import PreviewHtmlAndText from './previewHtmlAndtext';
import dayjs from 'dayjs';
import NoPreview from './noPreview';
import useUpdateNameOfFileOrFolder from '../../hooks/useUpdateNameofFileorFolder';

const FoldersAndFilesTable = ({
  data,
  tableData,
  setTableData,
  selectAll,
  setSelectAll,
}) => {
  const [menuPopover, setMenuPopover] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [renameModal, setRenameModal] = useState(false);
  const [previewPdfModal, setPreviewPdfModal] = useState(false);
  const [previewImageModal, setPreviewImageModal] = useState(false);
  const [previewVideo, setPreviewVideo] = useState(false);
  const [previewHtml, setPreviewHtml] = useState(false);
  const [moveFilesModal, setMoveFilesModal] = useState(false);
  const [copyOrMove, setCopyOrMove] = useState(null);
  const [noPreviewModal, setNoPreviewModal] = useState(false);
  const { id } = useParams();

  const extension = data?.name.split('.').pop();

  const [isCopied, setIsCopied] = useState(false);
  const ClearState = () => {
    setTimeout(() => {
      setIsCopied(false);
    }, 500);
  };

  const location = useLocation();
  const updateNameMutation = useUpdateNameOfFileOrFolder();

  return (
    <>
      <tr>
        <td>
          <div className='flex justify-center items-center pl-[20px] w-3'>
            <Checkbox
              size='xs'
              radius={'lg'}
              checked={data?.is_checked}
              onChange={() => {
                setTableData(() =>
                  tableData?.map((obj) => {
                    if (obj?.name === data?.name) {
                      return { ...obj, is_checked: !data?.is_checked };
                    }

                    return obj;
                  })
                );
              }}
            />
          </div>
        </td>
        {data?.is_directory ? (
          <Link
            to={`/app/repository/${id}`}
            state={{
              path: `${location?.state?.path}/${data?.name}`,
              mainpath: location?.state?.mainpath,
            }}
          >
            <td>
              <div
                className='flex item-center gap-2 text-[#848383] cursor-pointer '
                style={{
                  textAlign: 'start',
                  paddingLeft: '40px',
                  paddingTop: '10px',
                  paddingBottom: '10px',
                }}
              >
                <FolderIcon className='h-5 w-5' />

                <Tooltip
                  label={
                    <div>
                      <p>{data?.name}</p>
                      <hr className='opacity-30 my-2' />
                      <p className='text-right text-[#000] text-sm  opacity-80'>
                        Created by:-{' '}
                        <span className='font-semibold'>
                          {data?.directory_values[0]?.created_by__first_name}
                        </span>
                      </p>
                    </div>
                  }
                  width={280}
                  wrapLines
                  classNames={{
                    body: 'bg-white text-gray2 shadow-tooltip pr-3 z-0',
                  }}
                  radius='md'
                >
                  <p className='w-80 truncate'>{data?.name}</p>
                </Tooltip>
              </div>
            </td>
          </Link>
        ) : (
          <td>
            <div
              style={{
                textAlign: 'start',
                paddingLeft: '40px',
                paddingTop: '10px',
                paddingBottom: '10px',
              }}
              className='flex item-center  gap-2 text-[#848383] cursor-pointer mt-1'
            >
              {extension === 'svg' ||
              extension === 'png' ||
              extension === 'jpg' ? (
                <ImageIcon className='max-h-5 max-w-5' />
              ) : (
                <FileIcon className='max-h-5 max-w-5' />
              )}
              <Tooltip
                label={
                  <div>
                    <p>{data?.name}</p>
                    <hr className='opacity-30 my-2' />
                    <p className='text-right text-[#000] text-sm  opacity-80'>
                      Created by:-{' '}
                      <span className='font-semibold'>
                        {data?.directory_values[0]?.created_by__first_name}
                      </span>
                    </p>
                  </div>
                }
                width={250}
                wrapLines
                classNames={{
                  body: 'bg-white text-gray2 shadow-tooltip pr-3 z-0',
                }}
                radius='md'
              >
                <p className='w-80 truncate'>{data?.name}</p>
              </Tooltip>
            </div>
          </td>
        )}

        <td>
          <div className='flex  items-center justify-end gap-3 pr-[30px]'>
            <Tooltip
              label={
                <span
                  className={
                    isCopied
                      ? 'cursor-pointer text-sm p-1 text-[#28B446] font-semibold hover:bg-[#fae2d4]'
                      : 'cursor-pointer text-sm p-1 text-gray hover:bg-[#fae2d4]'
                  }
                >
                  {isCopied ? 'Copied' : 'Copy Link'}
                </span>
              }
              position='right'
              // withArrow
              classNames={{
                body: 'bg-white text-gray2 shadow-tooltip pr-3 z-0',
              }}
              radius='md'
            >
              {data?.is_directory ? null : (
                <CopyToClipboard
                  text={data?.url}
                  onCopy={() => {
                    setIsCopied(true);
                    ClearState();
                  }}
                >
                  <Copy className='h-5 w-5' />
                </CopyToClipboard>
              )}
            </Tooltip>
            <Popover
              opened={menuPopover}
              onClose={() => setMenuPopover(false)}
              target={
                <MenuDots
                  className='h-5 w-5 cursor-pointer'
                  onClick={() => setMenuPopover((o) => !o)}
                />
              }
              width={150}
              position='right-start'
              classNames={{ body: 'rounded-lg' }}
            >
              <div className='flex flex-col '>
                {data?.is_directory ? null : (
                  <p
                    className='cursor-pointer text-sm p-1 text-gray hover:bg-[#fae2d4]'
                    onClick={() => {
                      if (extension === 'pdf') {
                        setMenuPopover(false);
                        setPreviewPdfModal(true);
                      }
                      //  else if (
                      //   extension === 'htm' ||
                      //   extension === 'html' ||
                      //   extension === 'txt'
                      // ) {
                      //   setMenuPopover(false);
                      //   setPreviewHtml(true);
                      // }
                      // else if (extension === 'webm') {
                      //   setMenuPopover(false);
                      //   setPreviewImageModal(true);
                      // }
                      else if (
                        extension === 'jpg' ||
                        extension === 'svg' ||
                        extension === 'jfif' ||
                        extension === 'png'
                      ) {
                        setMenuPopover(false);
                        setPreviewImageModal(true);
                      } else if (
                        extension === 'mp4' ||
                        extension === 'gif' ||
                        extension === 'mp3'
                      ) {
                        setMenuPopover(false);
                        setPreviewVideo(true);
                      } else {
                        setMenuPopover(false);
                        setNoPreviewModal(true);
                      }
                    }}
                  >
                    Preview
                  </p>
                )}
                <p className='cursor-not-allowed opacity-50 text-sm p-1 text-gray hover:bg-[#fae2d4] '>
                  Share
                </p>
                {data?.is_directory ? null : (
                  <CopyToClipboard
                    text={data?.url}
                    onCopy={() => {
                      setIsCopied(true);
                      ClearState();
                    }}
                  >
                    <span
                      className={
                        isCopied
                          ? 'cursor-pointer text-sm p-1 text-[#28B446] font-semibold hover:bg-[#fae2d4]'
                          : 'cursor-pointer text-sm p-1 text-gray hover:bg-[#fae2d4]'
                      }
                    >
                      {isCopied ? 'Copied' : 'Copy Link'}
                    </span>
                  </CopyToClipboard>
                )}
                {/* <p className='cursor-pointer text-sm p-1 text-gray hover:bg-[#fae2d4]'>
                  Manage access
                </p> */}
                <hr className='text-[#8E8E8E] opacity-50' />
                {data?.is_directory ? null : (
                  <p
                    className='cursor-pointer text-sm p-1 text-gray hover:bg-[#fae2d4]'
                    onClick={() => {
                      saveAs(data?.url, data?.name);
                      setMenuPopover(false);
                    }}
                  >
                    Download
                  </p>
                )}
                <p
                  className='cursor-pointer text-sm p-1 text-gray hover:bg-[#fae2d4]'
                  onClick={() => {
                    setMenuPopover(false);
                    setOpenModal(true);
                  }}
                >
                  Delete
                </p>
                <p
                  className='cursor-pointer text-sm p-1 text-gray hover:bg-[#fae2d4]'
                  onClick={() => {
                    setMenuPopover(false);
                    setRenameModal(true);
                  }}
                >
                  Rename
                </p>
                <hr className='text-[#8E8E8E] opacity-50' />
                {/* <p className='cursor-pointer text-sm p-1 text-gray hover:bg-[#fae2d4]'>
                  Pin to top
                </p> */}

                <p
                  className='cursor-pointer text-sm p-1 text-gray hover:bg-[#fae2d4]'
                  onClick={() => {
                    setMenuPopover(false);
                    setMoveFilesModal(true);
                    setCopyOrMove('Copy');
                  }}
                >
                  Copy to
                </p>
                <p
                  className='cursor-pointer text-sm p-1 text-gray hover:bg-[#fae2d4]'
                  onClick={() => {
                    setMenuPopover(false);
                    setMoveFilesModal(true);
                    setCopyOrMove('Move');
                  }}
                >
                  Move to
                </p>
                <p
                  className='cursor-pointer text-sm p-1 text-gray hover:bg-[#fae2d4]'
                  onClick={() => {
                    setMenuPopover(false);
                    updateNameMutation.mutate({
                      path: `${location?.state?.path}/${data?.name}`,
                      is_pinned: !data?.directory_values[0]?.is_pinned,
                    });
                  }}
                >
                  {data?.directory_values[0]?.is_pinned
                    ? 'Unpin'
                    : 'Pin to top'}
                </p>
              </div>
            </Popover>
          </div>
        </td>
        <td className='text-center text-[#848383]'>
          {dayjs.unix(data?.stat?.updated_time).format('DD MMM YYYY, hh:mm A')}{' '}
        </td>
        <td>
          <div className='text-center text-[#848383]  flex justify-center items-center gap-2  '>
            {data?.directory_values[0]?.updated_by__first_name}
            {data?.directory_values[0]?.is_pinned ? <PinIcon /> : null}
          </div>
        </td>
        {/* <td className='text-center text-[#848383] text-sm '>
          05 May 2022, 12:00(static)
        </td>
        <td className='text-center text-[#848383] text-sm'>
          Hugh Grant, UX designer(static)
        </td> */}
      </tr>
      <DeleteSubFolderorFile
        openModal={openModal}
        setOpenModal={setOpenModal}
        isDirectory={data?.is_directory}
        path={location?.state?.path}
        name={data?.name}
      />
      <ReNameFolderOrFile
        isDirectory={data?.is_directory}
        path={location?.state?.path}
        name={data?.name}
        renameModal={renameModal}
        setRenameModal={setRenameModal}
      />
      <PreviewForPDF
        previewPdfModal={previewPdfModal}
        setPreviewPdfModal={setPreviewPdfModal}
        file={data?.url}
        name={data?.name}
      />
      <PreviewImage
        previewImageModal={previewImageModal}
        setPreviewImageModal={setPreviewImageModal}
        file={data?.url}
      />
      <PreviewVideo
        previewVideo={previewVideo}
        setPreviewVideo={setPreviewVideo}
        file={data?.url}
      />
      {copyOrMove && (
        <MoveFilesOrFolders
          moveFilesModal={moveFilesModal}
          setMoveFilesModal={setMoveFilesModal}
          path={[`${location?.state?.path}/${data?.name}`]}
          copyOrMove={copyOrMove}
          setCopyOrMove={setCopyOrMove}
        />
      )}
      <PreviewHtmlAndText
        previewHtml={previewHtml}
        setPreviewHtml={setPreviewHtml}
        file={data?.url}
      />
      <NoPreview
        noPreviewModal={noPreviewModal}
        setNoPreviewModal={setNoPreviewModal}
        file={data?.url}
        name={data?.name}
      />
    </>
  );
};

export default FoldersAndFilesTable;
